import React from "react";
import styled from "styled-components";

import { ClassroomUnit } from "@examspark/types";

const Styled = styled.div`
  font-family:
    proxima-nova,
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    "Roboto",
    "Oxygen",
    "Ubuntu",
    "Cantarell",
    "Fira Sans",
    "Droid Sans",
    "Helvetica Neue",
    sans-serif;
  padding: 0.5rem;
  font-size: 1.2rem;
  background-color: #f2f2f2;
  border-radius: 0.5rem;
  text-align: center;
  font-size: 1.1rem;
  height: 2.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  color: #777;
`;

const InProgress = styled(Styled)`
  background-color: #9089e6;
  color: #fff;
`;

const Skipped = styled(Styled)`
  background-color: transparent;
  color: orange;
  border: dashed 1px orange;
`;

const Completed = styled(Styled)`
  background-color: #5fc35f;
  color: #fff;
`;

const UnitStatusBadge = (props: { classroomUnit?: ClassroomUnit }) => {
  const { maturity } = props.classroomUnit || {};

  switch (maturity) {
    case "IN_PROGRESS":
      return <InProgress>In Progress</InProgress>;
    case "COMPLETE":
      return <Completed>Complete</Completed>;
    case "SKIPPED":
      return <Skipped>Skipped</Skipped>;
  }

  return <Styled>Not Started</Styled>;
};

export default UnitStatusBadge;
